import { useCodForm } from '../components/useCodForm';
import { sellsOnItsOwnPage } from '../themes/binding/shopPages';
import type { Commerce } from './ShopCommerce';

// Where Check out leads from the cart, shared by the drawer and the cart page: the checkout page for a shop
// whose order form has a page of its own, as Shopify's do, else the form one step on inside the drawer.

// Gives the cart's Check out: to the checkout page, or to the order form in the drawer.
export function useGoToCheckout(commerce: Commerce): () => void {
  const config = useCodForm();
  const ownPage = config !== null && sellsOnItsOwnPage(config.checkoutDisplay);
  return () => commerce.checkoutCart(ownPage);
}
